import React from 'react';
import './Features.css';

function Features() {
  const features = [
    {
      icon: '⚡',
      title: 'Gerçek Zamanlı İzleme',
      description: 'Enerji akışı, gerilim, akım ve güç faktörlerini saniyelik olarak izleyin. Canlı dashboard ile hızlı karar alma.',
      details: ['Saniyelik veri güncellemeleri', 'Canlı dashboard', 'Gerilim ve akım izleme', 'Güç faktörü analizi']
    },
    {
      icon: '🔔',
      title: 'Akıllı Alarm Sistemi',
      description: 'Kritik durumlarda anında bildirim. Enerji anomalileri ve eşik değer aşımlarında otomatik uyarı sistemi.',
      details: ['Anında bildirimler', 'E-posta, SMS, mobil bildirim', 'Enerji anomali tespiti', 'Eşik değer aşım uyarıları']
    },
    {
      icon: '🤖',
      title: 'Yapay Zeka Destekli Analiz',
      description: 'AI destekli anomali tespiti ve trend analizi ile gelecek tüketim tahminleri yapın.',
      details: ['Anomali tespiti', 'Trend analizi', 'Tüketim tahminleri', 'Makine öğrenmesi algoritmaları']
    },
    {
      icon: '🌐',
      title: 'IoT Entegrasyonu',
      description: 'Sensör, röle, akıllı priz ve kompanzasyon cihazlarını tek platformda yönetin.',
      details: ['Sensör entegrasyonu', 'Akıllı priz kontrolü', 'Röle yönetimi', 'Kompanzasyon takibi']
    },
    {
      icon: '📊',
      title: 'Detaylı Raporlama',
      description: 'Enerji kalitesi, harmonik analizi, raporlama ve verimlilik göstergeleri.',
      details: ['Enerji kalitesi raporları', 'Harmonik analizi', 'Verimlilik göstergeleri', 'Export/Import yönetimi']
    },
    {
      icon: '🏢',
      title: 'Tesis Yönetimi',
      description: 'Çoklu tesis ve lokasyon yönetimi. Harita üzerinde konum bazlı enerji profilleri.',
      details: ['Çoklu tesis yönetimi', 'Harita entegrasyonu', 'Lokasyon bazlı analiz', 'Tesis karşılaştırması']
    },
    {
      icon: '⚡',
      title: 'Enerji Optimizasyonu',
      description: 'Kompanzasyon takibi, reaktif oran paneli ve talep kontrol sistemi ile enerji verimliliği.',
      details: ['Kompanzasyon takibi', 'Reaktif oran paneli', 'Talep kontrol sistemi', 'Enerji kalitesi izleme']
    },
    {
      icon: '👥',
      title: 'Kullanıcı Yönetimi',
      description: 'Rol bazlı yetkilendirme ve çok kullanıcılı yapı ile güvenli erişim kontrolü.',
      details: ['Rol bazlı yetkilendirme', 'Kullanıcı yönetimi', 'Veri görünürlük kontrolü', 'Departman bazlı erişim']
    },
    {
      icon: '🔗',
      title: 'Entegrasyonlar',
      description: 'SCADA, muhasebe sistemi ve ulusal enerji sistemleri ile sorunsuz veri alışverişi.',
      details: ['EPİAŞ entegrasyonu', 'EPDİAŞ bağlantısı', 'TEİAŞ entegrasyonu', 'Muhasebe sistemi bağlantısı']
    },
    {
      icon: '📱',
      title: 'Mobil Uygulama',
      description: 'iOS ve Android uygulamaları ile her yerden erişim. Push notification ile anlık alarmlar.',
      details: ['iOS uygulaması', 'Android uygulaması', 'Push bildirimleri', 'Offline mod desteği']
    }
  ];

  return (
    <div className="features">
      <div className="features-header">
        <h1>🚀 Özellikler</h1>
        <p>Enerji Takip uygulamasının güçlü özelliklerini keşfedin</p>
      </div>

      <div className="features-content">
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-header">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
              </div>
              <p className="feature-description">{feature.description}</p>
              <ul className="feature-details">
                {feature.details.map((detail, detailIndex) => (
                  <li key={detailIndex}>
                    <span className="checkmark">✓</span>
                    {detail}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="features-cta">
          <h2>Tüm Özellikleri Deneyin!</h2>
          <p>Enerji Takip uygulamasının tüm güçlü özelliklerini ücretsiz olarak deneyin.</p>
          <div className="cta-buttons">
            <a href="/dashboard" className="cta-primary">
              🎯 Hemen Başla
            </a>
            <a href="/guide" className="cta-secondary">
              📖 Kullanım Rehberi
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Features;
